import React, { Component } from 'react';
import NewsService from '../../src/services/News.service';
import NewsConfiguration from '../../src/models/NewsConfiguration';
import Cookies from 'universal-cookie';
import NewsWidgetPage from './views/pages/NewsWidgetPage';

type AppProps = {
    imageUrl: string,
    region: string;
}

type AppState = {
    configuration: NewsConfiguration,
    seenNews: string[],
}
export default class App extends Component<AppProps, AppState> {
    constructor(props: AppProps) {
        super(props);
        this.state = {
          configuration: new NewsConfiguration(),
          seenNews: [],
        };
      }

      public async componentDidMount() {
        const cookies = new Cookies();
        const seenNews = cookies.get('seenNewsWidget');

        const service: NewsService = new NewsService();
        const configuration: NewsConfiguration = await service.getConfiguration(this.props.region);
        configuration.imageUrl = this.props.imageUrl;

        this.setState({
          configuration: configuration,
          seenNews: seenNews ?? [],
        });
      }

      public render() {
        return (
          <>
            {
                this.state.configuration.articles.length > 0 &&
                this.state.configuration.articles.some(article => !this.state.seenNews.includes(article.nodeGUID)) &&
                <NewsWidgetPage configuration={this.state.configuration}></NewsWidgetPage>
            }
          </>
        );
      }
}